// extracted by mini-css-extract-plugin
export default {"container":"MultipleSelect_container__AhkqK"};